module.exports = __webpack_public_path__ + "img/icon_chart-vertical.c2b50ea7.svg";